// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!components/ui/common.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._44f95d{align-items:flex-start;display:flex;flex-wrap:wrap;gap:.5em}._99c961{font-size:1.142em}.f0e568{justify-content:center}", ""]);
// Exports
exports.locals = {
	"tags": "_44f95d " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["small-spacing"] + "",
	"normal-size": "_99c961",
	"normalSize": "_99c961",
	"center": "f0e568"
};
module.exports = exports;
